import { FC } from 'react'

import styled from 'styled-components'

import { getIsLanguageActive } from 'src/Pages/Artist/SpotifySchedulePage/helpers/helpers'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { ProperGenreOrLanguage } from 'src/Types/tracks'
import { ModalType, ScheduleSteps } from 'src/Types/ui'
import { ANY_LANGUAGE_ID } from 'src/Constants/constants'
import { capitalizeFirstLetter } from 'src/Helpers/layoutHelpers'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { AddParameterButton } from 'src/Components/Buttons/AddParameterButton'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
  gap: 1px;
`
const SubTitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const LanguagesList = styled(SubTitle)`
  font-weight: 400;
`

interface ScheduleLanguagesProps {
  languages: ProperGenreOrLanguage[]
}

export const SpotifyScheduleLanguage: FC<ScheduleLanguagesProps> = ({
  languages,
}) => {
  const { setSearch } = useCustomSearchParams()

  const isLanguageActive = getIsLanguageActive(languages)

  const handleClick = (): void => {
    const query = {
      step: ScheduleSteps.SETTINGS,
      modal: ModalType.Languages,
    }
    setSearch(query)
  }

  if (isLanguageActive) {
    return (
      <AddParameterButton onClick={handleClick}>
        Add track language
      </AddParameterButton>
    )
  }

  const lang = languages.find((item) => item.id !== ANY_LANGUAGE_ID)

  const language = `${capitalizeFirstLetter(lang?.name ?? '')}`
  return (
    <Container>
      <Wrapper>
        <SubTitle>Track language</SubTitle>
        <LanguagesList translate='no'>{language}</LanguagesList>
      </Wrapper>
      <PrimaryDottedButton onClick={handleClick}>Edit</PrimaryDottedButton>
    </Container>
  )
}
